import React, { memo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CardHeader, ListItemIcon, ListItemText, Menu, MenuItem } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { logoutUserAction, setNotifSoundSettingAction } from '../../appContainer/actions';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';
import ResetPassword from '../ResetPassword/ResetPassword';
import { RenewIcon, TranslateIcon, VolumeOffIcon, VolumeUpIcon } from '../../icons';
import { createStructuredSelector } from 'reselect';
import { getRolesSelector, notificationSoundSettingSelector } from '../../appContainer/selectors';
import ChangeLanguage from '../ChangeLanguage';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import AvatarWrapper from '../AvatarWrapper/AvatarWrapper';

const stateSelector = createStructuredSelector({
  roles: getRolesSelector,
  notifSounds: notificationSoundSettingSelector,
});

const UserProfileMenu = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { roles, notifSounds } = useSelector(stateSelector);

  const moreRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleLogout = () => {
    dispatch(logoutUserAction.Request());
  };

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const handleSoundsChange = () => {
    dispatch(setNotifSoundSettingAction.Completed(!notifSounds));
  };

  const { user } = props;
  const userFullName = `${user.firstName} ${user.lastName}`;

  const UserRole = (
    <Typography className={classes.subheader}>
      <FormattedMessage {...messages.role} values={{ role: roles[user.role] || '' }} />
    </Typography>
  );

  return (
    <>
      <Button ref={moreRef} className={classes.topNavUserInfoButton} color="inherit" onClick={handleMenuOpen}>
        <CardHeader
          avatar={<AvatarWrapper imageUrl={user.imageUrl} name={userFullName} />}
          className={classes.topNavUserInfo}
          subheader={
            <Typography className={classes.title} variant="body1">
              {UserRole}
            </Typography>
          }
          title={
            <Typography className={classes.title} variant="body1">
              {userFullName}
            </Typography>
          }
        />
      </Button>

      <Menu
        anchorEl={moreRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        classes={{ paper: classes.menu }}
        onClose={handleMenuClose}
        open={openMenu}
        transformOrigin={{
          vertical: -60,
          horizontal: 'right',
        }}>
        <MenuItem>
          <ListItemIcon>
            <RenewIcon />
          </ListItemIcon>
          <ResetPassword />
        </MenuItem>

        <Divider />

        <MenuItem>
          <ListItemIcon>
            <TranslateIcon />
          </ListItemIcon>
          <ChangeLanguage />
        </MenuItem>

        <Divider />

        <MenuItem onClick={handleSoundsChange}>
          <ListItemIcon>{notifSounds ? <VolumeUpIcon /> : <VolumeOffIcon />}</ListItemIcon>
          <FormattedMessage {...(notifSounds ? messages.soundsOn : messages.soundsOff)} />
        </MenuItem>

        <Divider />

        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <InputIcon />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage {...messages.logout} />
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

UserProfileMenu.propTypes = {
  className: PropTypes.string,
  user: PropTypes.any.isRequired,
};

export default memo(UserProfileMenu);
